module.exports = __webpack_public_path__ + "assets/img/103.4d62e116.png";